module.exports = __webpack_public_path__ + "img/Malta.2c445c36.png";